// Desconto comercial do pedido: só reduz o total daquele pedido.
export const round2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

export function discountCalc(subtotal, type, value) {
  const sub = round2(subtotal);
  const val = round2(value);
  if (!type || !val) return { subtotal: sub, amount: 0, total: sub, error: "" };
  if (val < 0) return { subtotal: sub, amount: 0, total: sub, error: "O desconto não pode ser negativo." };
  if (type === "PERCENTUAL") {
    if (val > 100)
      return { subtotal: sub, amount: 0, total: sub, error: "O percentual não pode passar de 100%." };
    const amount = round2((sub * val) / 100);
    return { subtotal: sub, amount, total: round2(sub - amount), error: "" };
  }
  if (val > sub)
    return { subtotal: sub, amount: 0, total: sub, error: "O desconto não pode ser maior que o subtotal." };
  return { subtotal: sub, amount: val, total: round2(sub - val), error: "" };
}
